import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import { authAction } from "../../../data/redux/action/authAction";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../../data/redux/action/fullScreenLoadingAction";
import { OTP_RESEND_TIME } from "../../../utility/Constants";
import ResizeListener from "../../../utility/ResizeListener";
import secureStorage from "../../../utility/secureStorage";
import { CustomButton } from "../../components/customButton/CustomButton";
import { CustomInput } from "../../components/customInput/CustomInput";
import { NeokredNewLogo, NeokredTriangle } from "../../resources/assetsManager";
import { LOGIN_BG_COLOR, WHITE_COLOR } from "../../resources/colorsManager";
import { SUCCESS } from "../../resources/constantsManager";
import {
  SS_CASH_FREE,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_MOBILE_NUMBER,
  SS_REF_HASH_ID,
  SS_ROLE,
  SS_UPI_ENABLED,
} from "../../resources/secureStorageManager";
import { EmailArray } from "../../../data/arrayData";

function OtpVerifyScreen({
  email,
  onSuccess,
  isFromForgotPass = false,
  forgotpassword,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [otpSentCount, setOtpSentCount] = useState(0);
  const { height, width } = ResizeListener();
  const [disabled, setDisabled] = useState(true);
  const [timeCount, setTimeCount] = useState(OTP_RESEND_TIME);
  const [otpResent, setOtpResent] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [emailDomain, setEmailDomain] = useState("");
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickVerify = () => {
    setLoading(true);
    dispatch(startFullScreenLoadingAction());
    if (isFromForgotPass) {
      ApiRequestPost.verifyOtpForgotPassword(email, otp)
        .then((data) => {
          if (data.status === SUCCESS) {
            enqueueSnackbar(data.message, {
              variant: "success",
            });
            onSuccess();
          } else {
            enqueueSnackbar(data.message, {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          enqueueSnackbar(error.message, {
            variant: "error",
          });
        })
        .finally(() => {
          dispatch(stopFullScreenLoadingAction());
          setLoading(false);
        });
    } else {
      ApiRequestPost.verifyOtp(email, otp)
        .then((data) => {
          console.log(data);
          if (data.status === SUCCESS) {
            enqueueSnackbar(data.message, {
              variant: "success",
            });
            secureStorage.setItem(SS_REF_HASH_ID, data?.data?.refHashId);
            secureStorage.setItem(SS_MOBILE_NUMBER, data?.data?.mobileNumber);
            secureStorage.setItem(SS_EMAIL, data?.data?.email);
            secureStorage.setItem(SS_FIRST_NAME, data?.data?.firstName);
            secureStorage.setItem(SS_ROLE, data?.data?.role);
            secureStorage.setItem(SS_LAST_NAME, data?.data?.lastName);
            //data?.data?.cashFree
            // secureStorage.setItem(SS_CASH_FREE, data?.data?.cashFree);
            // secureStorage.setItem(
            //   SS_UPI_ENABLED,
            //   EmailArray.includes(data?.data?.email) ? true : false
            // );
            secureStorage.setItem("setupTime", new Date().getTime());
            dispatch(authAction(true));
            navigate("/dashboard");
          } else {
            enqueueSnackbar(data.message, {
              variant: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          enqueueSnackbar(err.message, {
            variant: "error",
          });
        })
        .finally(() => {
          dispatch(stopFullScreenLoadingAction());
          setLoading(false);
        });
    }
  };

  const onClickResendOtp = () => {
    ApiRequestPost.sendOtpForForgotPassword(email)
      .then((data) => {
        console.log(data);
        if (data.status === SUCCESS) {
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          setOtpResent(true);
          setTimeCount(OTP_RESEND_TIME);
          setOtpSentCount(otpSentCount + 1);
        } else {
          enqueueSnackbar(data.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };
  useEffect(() => {
    let newemail = email?.split("@");
    var userEmail = newemail[0].slice(0, -3);
    var domain = newemail[1];
    setEmailDomain(domain);
    setUserEmail(userEmail);
  }, []);

  const resendOtp = () => {
    otpSentCount < 3 && onClickResendOtp();
  };

  useEffect(() => {
    if (otp.length >= 6) {
      setDisabled(false);
    } else setDisabled(true);
  }, [otp]);

  useEffect(() => {
    if (timeCount > 0) {
      setTimeout(() => {
        setTimeCount(timeCount - 1);
      }, 1000);
    } else setOtpResent(false);
  }, [timeCount]);

  useEffect(() => {
    setOtpResent(true);
  }, []);

  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: WHITE_COLOR,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div>
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: LOGIN_BG_COLOR,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            {isFromForgotPass ? "Verify OTP" : "Verify Email"}
          </p>
          <p
            style={{
              fontSize: 16,
              marginBottom: 30,
              color: "black",
              margin: 0,
              marginTop: 5,
              fontWeight: "400",
            }}
            className="roboto"
          >
            {forgotpassword
              ? `To reset the password Please enter the OTP shared on the ${userEmail}***@${emailDomain}`
              : `OTP has been sent to ${userEmail}***@${emailDomain}`}
          </p>

          <div style={{ marginTop: "25px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              Enter OTP<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomInput
              type={"input"}
              value={otp}
              placeholder="1234XX"
              onChange={setOtp}
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              inputcomponentStyles={{ letterSpacing: 5 }}
              validator="otp"
              onPressEnter={() => {
                onClickVerify();
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                marginTop: "5px",
              }}
            >
              {!otpResent ? (
                otpSentCount >= 3 ? (
                  <>
                    <p
                      style={{
                        color: "#3783FB",
                        cursor: "pointer",
                        margin: 0,
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                      className="roboto"
                    >
                      Maximun limit exceeded
                    </p>
                  </>
                ) : (
                  <p
                    style={{
                      color: "#3783FB",
                      cursor: "pointer",
                      margin: 0,
                      fontSize: "12px",
                    }}
                    onClick={resendOtp}
                    className="roboto"
                  >
                    Resend OTP
                  </p>
                )
              ) : (
                <p
                  style={{
                    color: "black",
                    margin: 0,
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                  className="roboto"
                >
                  You can request new OTP after{" "}
                  <span
                    style={{
                      fontSize: 12,
                      color: "#3783FB",
                    }}
                    className="roboto"
                  >
                    {timeCount} Seconds
                  </span>
                </p>
              )}
            </div>
          </div>
          <CustomButton
            loading={loading}
            title="Verify"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 40,
              height: "50px",
            }}
            textStyle={{
              color: WHITE_COLOR,
              fontSize: 15,
              fontWeight: 500,
            }}
            onClick={onClickVerify}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}

export default OtpVerifyScreen;
